import { useEffect, useState } from "react";

import { useSearchParams } from "@shared/react-router-dom";
import type { WellevateSignupFormData } from "@unauthenticated/wellevateAuthorize/practitioners/types";
import { AccountCreationStep } from "@unauthenticated/wellevateAuthorize/practitioners/types";

import { WellevateAccountDetailsPage } from "../WellevateAccountDetailsPage";
import { WellevateAccountErrorPage } from "../WellevateAccountErrorPage";
import { WellevateAuthenticationPage } from "../WellevateAuthenticationPage";
import { WellevateLandingPage } from "../WellevateLandingPage";
import { WellevateRegistrationPage } from "../WellevateRegistrationPage";

const MigrationAccountCreationFlow = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentStep = searchParams.get("step");

  const [formData, setFormData] = useState<WellevateSignupFormData>({
    email: "",
    firstName: "",
    lastName: "",
    dispensaryName: "",
    practitionerTypeId: "",
    practitionerType: "",
    wellevatePractitionerId: "",
    tosTimestamp: "",
  });

  useEffect(() => {
    if (
      !formData.wellevatePractitionerId &&
      !!currentStep &&
      currentStep !== AccountCreationStep.ACCOUNT_ERROR &&
      currentStep !== AccountCreationStep.WELLEVATE_AUTH
    ) {
      setSearchParams({ step: AccountCreationStep.WELLEVATE_AUTH });
    }
  }, [currentStep]);

  const renderCurrentStep = () => {
    switch (currentStep) {
      case AccountCreationStep.WELLEVATE_AUTH:
        return <WellevateAuthenticationPage setFormData={setFormData} />;
      case AccountCreationStep.ACCOUNT_ERROR:
        return <WellevateAccountErrorPage email={formData.email} />;
      case AccountCreationStep.ACCOUNT_DETAILS:
        return <WellevateAccountDetailsPage formData={formData} onSetFormData={setFormData} />;
      case AccountCreationStep.ACCOUNT_CREATION:
        return <WellevateRegistrationPage formData={formData} />;
      default:
        return <WellevateLandingPage />;
    }
  };

  return <>{renderCurrentStep()}</>;
};

export { MigrationAccountCreationFlow };
